
export default {
  name: "RestSchedule",
  props: {
    review: {
      type: Boolean,
      required: false,
      default: false,
    },
    monthDate: {
      type: Date,
      required: false,
      default: null,
    },
    employee: {
      type: Object,
      required: false,
      default: null,
    },
  },
  created() {
    let t = this;

    let d = new Date();

    if (t.monthDate) {
      t.year = Number(t.monthDate.getFullYear());
      t.month = Number(t.monthDate.getMonth() + 1);
    }

    if (t.year == 0)
      t.year = d.getFullYear();

    if (t.month == 0)
      t.month = d.getMonth() + 2;

    t.holiday = t.dict.holiday[t.month];

  },
  activated() { },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {

      let t = this;

      let p = {};

      p.employee_id = t.employee.id;

      axios.get('employeeConfig', { params: p }).then(res => {

        if (res.data.status == 1) {

          if (res.data.options.items.length == 0) {
            A.err('あなたの出退勤時間が設定されていません。管理者に連絡して処理してください。');
          }
          else {

            t.config = res.data.options.items[0];

            t.config.static_rest_day = t.config.static_rest_day.split(',');

            t.list.rest_day.forEach(item => {

              item.static_rest = false;

              if (t.config.static_rest_day.indexOf(item.id.toString()) > -1)
                item.static_rest = true;

            });

            let arr = JSON.parse(t.config.att_config);

            t.config.att_config = arr;

            arr.forEach(item => {
              item.text = item.start + '-' + (item.tomorrow == 1 ? '翌日' : '') + item.end;
            });

            t.list.attTimeRange = arr;

            t.list.attTimeRange_am = [];
            t.list.attTimeRange_pm = [];

            t.list.attTimeRange.forEach(item => {

              let date1 = new Date('2025-01-01 ' + item.start);
              let date2 = new Date('2025-01-01 ' + item.end);
              let tomorrow2 = 0;
              if (item.tomorrow == 1) {
                date2 = new Date('2025-01-02 ' + item.end);
              }
              let timeDifferenceInMillis = Math.abs(date2 - date1);
              let minutesDiff = timeDifferenceInMillis / (1000 * 60);

              minutesDiff = (minutesDiff - 60) / 2;

              date2.setMinutes(-minutesDiff);

              let text = date2.format('hh:mm') + '-' + item.end;

              if (item.tomorrow == 1) {
                if (date2.getDate() == 2) {
                  text = '翌日' + date2.format('hh:mm') + '-' + item.end;
                  tomorrow2 = 1;
                }
              }

              t.list.attTimeRange_pm.push({
                'start': date2.format('hh:mm'),
                'end': item.end,
                'text': text,
                'tomorrow': item.tomorrow,
                'tomorrow2': tomorrow2
              });

              date1 = new Date('2025-01-01 ' + item.start);
              date2 = new Date('2025-01-01 ' + item.end);
              if (item.tomorrow == 1) {
                date2 = new Date('2025-01-02 ' + item.end);
              }

              date1.setMinutes(date1.getMinutes() + minutesDiff);

              text = item.start + '-' + date1.format('hh:mm');

              if (item.tomorrow == 1) {
                if (date1.getDate() == 2 && date2.getDate() == 2) {
                  text = item.start + '-翌日' + date1.format('hh:mm');
                  tomorrow2 = 1;
                }
              }

              t.list.attTimeRange_am.push({
                'start': item.start,
                'end': date1.format('hh:mm'),
                'text': text,
                'tomorrow': item.tomorrow,
                'tomorrow2': tomorrow2
              });

            });

            t.loadMonthly();
          }
        }
      });

    },

    minusMonth() {
      let t = this;
      let r = addMonthsToDate(new Date(t.year, t.month - 1, 1), -1);
      t.month = r.getMonth() + 1;
      t.holiday = t.dict.holiday[t.month];
      t.year = r.getFullYear();
      t.loadMonthly();
    },

    plusMonth() {
      let t = this;
      let r = addMonthsToDate(new Date(t.year, t.month - 1, 1), 1);
      t.month = r.getMonth() + 1;
      t.holiday = t.dict.holiday[t.month];
      t.year = r.getFullYear();
      t.loadMonthly();
    },

    loadMonthly() {
      let t = this;

      let dayIndexs = ["日", "月", "火", "水", "木", "金", "土"];

      t.list.dateGrid.clear();

      let params = {
        'month': t.month,
        'year': t.year
      };

      params.employee_id = t.employee.id;

      t.list.dateGrid = [];
      t.list.placeholder = [];

      axios
        .get("attScheduleReview", { params: params })
        .then((res) => {
          if (res.data.status == 1) {

            let lastSubmitDict = {};

            t.lastSubmit = res.data.options.items[0];

            if (t.lastSubmit) {
              lastSubmitDict = listToDict(JSON.parse(t.lastSubmit.data), 'date');
            }

            let dictDate = {};

            let day = getDaysInMonth(t.year, t.month);

            let entryDate = new Date(t.employee.entry_date);

            for (let i = 0; i < day; i++) {
              let curDate = new Date(t.year, t.month - 1, i + 1);
              let date = curDate.format("MM/dd");
              let item = {
                full_date: curDate.format("yyyy-MM-dd"),
                date: date,
                day_index_text: dayIndexs[curDate.getDay()],
                day_index: curDate.getDay(),
                static_rest: t.config.static_rest_day.indexOf(curDate.getDay().toString()) > -1 ? 1 : 0,
                showAttTimeRange: false,
                //调休
                dynamic_rest: 0,
                before_entry: curDate < entryDate,
                disabledRest: false,
              };
              item.f = {
                work: 1,
                att_time_range: null,
                rest_to_work: 0,
                rest_date: '',
                start_time: '',
                end_time: '',
                rest_am: 0,
                rest_pm: 0,
                tomorrow: 0,
                tomorrow2: 0,
                att_text: ''
              };

              if (t.config.att_config && t.config.att_config.length > 0 && item.static_rest == 0) {
                item.f.att_time_range = t.config.att_config[0];
                item.f.start_time = item.f.att_time_range.start;
                item.f.end_time = item.f.att_time_range.end;
                item.f.tomorrow = item.f.att_time_range.tomorrow;
                item.f.att_text = item.f.start_time + '-' + (item.f.tomorrow ? '翌日' : '') + item.f.end_time;
              }

              if (lastSubmitDict[item.full_date]) {
                mirror(lastSubmitDict[item.full_date], item.f);
                item._oldF = lastSubmitDict[item.full_date];
                if (item.f.rest_am || item.f.rest_pm) {
                  item.disabledRest = true;
                }
              }

              if (t.holiday && item.f.work == 3) {
                t.holiday.left--;
              }

              t.list.dateGrid.push(item);
              dictDate[item.full_date] = item;
            }
            
            for (const date in lastSubmitDict) {
              let dateItem = lastSubmitDict[date];

              if (dateItem.rest_to_work == 1 && dictDate[dateItem.rest_date]) {
                dictDate[dateItem.rest_date].dynamic_rest = 1;
                dictDate[dateItem.rest_date].work_date = (new Date(date)).format('MM/dd');
              }

            }

            let days = new Date(t.list.dateGrid[0].full_date).getDay();

            t.list.placeholder = [];

            if (days == 0) {
              days = 6;
            } else {
              days--;
            }

            for (let j = 0; j < days; j++) {
              t.list.placeholder.push("");
            }

          }
        });
    },

    onSelectAttTimeRange(option, item) {
      item.f.start_time = option.start;
      item.f.end_time = option.end;
      item.f.tomorrow = option.tomorrow;
      item.f.att_text = option.text;
    },

    buildData() {
      let t = this;

      let arr = [];
      let dict = {};

      for (let i = 0; i < t.list.dateGrid.length; i++) {
        let item = t.list.dateGrid[i];
        let f = item.f;

        if (item.dynamic_rest == 1) {
          continue;
        }

        if (item.static_rest == 0 || item.f.rest_to_work) {

          if (item.f.rest_to_work && !item.f.rest_date) {
            A.err(item.date + 'の振替休日がまだ選択されていません。');
            return;
          }

          if (!item.before_entry) {
            if (!item.f.start_time && (!item.f.rest_am && !item.f.rest_pm) && (item.f.work == 1 || item.f.work == 2)) {
              A.err(item.date + 'の出勤時間が指定されていません。');
              return;
            }
            let _item = {
              'date': item.full_date,
              'start_time': f.work > 0 && f.work != 3 ? f.start_time : '',
              'end_time': f.work > 0 && f.work != 3 ? f.end_time : '',
              'rest_am': f.rest_am ? 1 : 0,
              'rest_pm': f.rest_pm ? 1 : 0,
              'att_text': f.work > 0 && f.work != 3 ? f.att_text : ''
            };

            dict[item.full_date] = _item;
          }

        }
      }

      if (t.lastSubmit) {
        let lastSubmitDict = listToDict(JSON.parse(t.lastSubmit.data), 'date');

        for (const date in dict) {
          let source = lastSubmitDict[date];
          let leave = dict[date];

          if (leave.rest_am != source.rest_am || leave.rest_pm != source.rest_pm) {
            arr.push(leave);
          }
        }
      }

      return arr;
    },

    allIsLeave() {

      let t = this;

      t.f.type = 2;
      t.f.timespan = 2;

      for (let i = 0; i < t.list.dateGrid.length; i++) {

        let item = t.list.dateGrid[i];

        if (item.dynamic_rest == 1) {
          continue;
        }

        if (item.static_rest == 0 || item.f.rest_to_work) {
          if (!item.before_entry) {
            item.f.rest_am = 1;
            item.f.rest_pm = 1;
          }

        }
      }

    },

    submit(isProxy) {

      let t = this;

      let arr = t.buildData();

      if (arr && arr.length > 0) {

        let f = t.f;

        f.leave_data = JSON.stringify(arr);
        f.date = arr[0].date;
        f.employee_id = t.employee.id

        if (!f.description) {
          A.err('申請理由をご記入ください。');
          return;
        }

        if (t.busying)
          return;

        t.busying = true;

        axios.post('clockIn/submitLeave', f).then(res => {

          t.busying = false;

          if (res.data.status == 1) {
            A.show('すでに提出済みですので、管理者の審査を今しばらくお待ちください。', '休暇申請', 'success').then(res => {
              t.$emit('close', isProxy ? 2 : 1);
            });
          }
        });

      }
      else {
        A.err('変更は検出されませんでした。');
      }

    },

    getAttTimeRange(start_time, end_time, suffix) {

      let t = this;

      let index = 0;

      suffix = suffix || '';

      t.list.attTimeRange.forEach((item, i) => {
        if (item.start == start_time && item.end == end_time) {
          index = i;
        }
      });

      t.list.attTimeRange_am.forEach((item, i) => {
        if (item.start == start_time && item.end == end_time) {
          index = i;
        }
      });

      t.list.attTimeRange_pm.forEach((item, i) => {
        if (item.start == start_time && item.end == end_time) {
          index = i;
        }
      });

      return t.list['attTimeRange' + suffix][index];

    },

    restChange(item, type) {

      let t = this;
      let attTimeRange = null;

      if (t.f.timespan == 2) {

        if (type == 'am') {
          item.f.rest_pm = item.f.rest_am;
        }
        else if (type == 'pm') {
          item.f.rest_am = item.f.rest_pm;
        }
      }

      if (item.f.rest_am && item.f.rest_pm) {
        item.f.work = 0;
      }
      else if (!item.f.rest_am && !item.f.rest_pm) {

        item.f.work = 1;

        attTimeRange = t.getAttTimeRange(item.f.start_time, item.f.end_time);
        item.f.start_time = attTimeRange.start;
        item.f.end_time = attTimeRange.end;
        item.f.att_text = attTimeRange.text;
        item.f.tomorrow = attTimeRange.tomorrow;
        item.f.tomorrow2 = attTimeRange.tomorrow2;

      }
      else {
        item.f.work = 1;

        if (item.f.rest_am) {
          attTimeRange = t.getAttTimeRange(item.f.start_time, item.f.end_time, '_pm');
        }
        else if (item.f.rest_pm) {
          attTimeRange = t.getAttTimeRange(item.f.start_time, item.f.end_time, '_am');
        }

        item.f.start_time = attTimeRange.start;
        item.f.end_time = attTimeRange.end;
        item.f.att_text = attTimeRange.text;
        item.f.tomorrow = attTimeRange.tomorrow;
        item.f.tomorrow2 = attTimeRange.tomorrow2;

      }

      if (item.f.rest_am || item.f.rest_pm) {
        if (t.f.timespan == 1) {
          t.list.dateGrid.forEach(dateItem => {
            if (dateItem != item && dateItem._oldF) {
              mirror(dateItem._oldF, dateItem.f);
            }
          });
        }
      }
    },

    back() {
      let t = this;

      let arr = t.buildData();
      if (arr && arr.length > 0) {
        A.safety('フォームの変更はまだ提出されていません。本当に戻りますか？', 'info').then(res => {
          if (res.isConfirmed) {
            t.$emit('close', 0);
          }
        })
      }
      else {
        t.$emit('close', 0);
      }
    }

  },
  data() {
    return {
      year: 0,
      month: 0,
      allowModify: true,
      ready: false,
      busying: false,
      config: null,
      lastSubmit: null,
      editable: false,
      holiday: null,
      dict: {
        holiday: {
          5: {
            days: 3,
            name: 'GW',
            left: 3
          },
          8: {
            days: 3,
            name: '盆休',
            left: 3
          }
        },
      },
      f: {
        type: 1,
        timespan: 1,
        description: ''
      },
      list: {
        dateGrid: [],
        placeholder: [],
        attTimeRange: [],
        attTimeRange_am: [],
        attTimeRange_pm: [],
        rest_day: [
          { id: 1, text: "月" },
          { id: 2, text: "火" },
          { id: 3, text: "水" },
          { id: 4, text: "木" },
          { id: 5, text: "金" },
          { id: 6, text: "土" },
          { id: 0, text: "日" },
        ],
      },
      item: null,
      search: {
        employee: null,
      },
      stats: {
        rest_day_left: 0,
      },
    };
  },
};
